<template>
  <div class="project">
    <div class="change_lang">
      <div class="title">
        <h2>{{$t('lang.project_info_title')}}</h2>
      </div>
      <div class="btn">
        <span
          v-on:click="changeTab(1)"
          :class="{ active:isChina }"
        >{{$t('lang.project_info_btn1')}}</span>
        <span
          v-on:click="changeTab(0)"
          :class="{ active:!isChina }"
        >{{$t('lang.project_info_btn2')}}</span>
      </div>
    </div>
    <div class="project_list">
      <ul>
        <li v-for="item in project_list" :key="item.index">
          <div class="img" v-on:click="showPop(item)">
            <img :src=" 'http://moderncap.pengjisoft.com/'+ item.logo" alt>
          </div>
        </li>
      </ul>
    </div>
    <pop-box v-if="isPop" :pop_data="pop_data" v-on:hidePop="hidePop"/>
  </div>
</template>

<script>
import PopBox from "../components/pop_preview";
import axios from "axios";
export default {
  components: {
    PopBox
  },
  mounted() {
    this.project_list = this.guonei;
  },
  data() {
    return {
      isChina: true, //国内项目,
      isPop: false,
      pop_data: {},
      guonei_list: [],
      jingwai_list: [],
      project_list: []
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData: function(url) {
      var getUrl = url
        ? url
        : "http://moderncap.pengjisoft.com/api/project/get_all?page=1";
      axios.get(getUrl).then(res => {
        let data = res.data;
        let value = data.data;
        value.map(item => {
          if (item.type === 1) {
            this.guonei_list.push(item);
          } else {
            this.jingwai_list.push(item);
          }
        });
        if (this.jingwai_list.length + this.guonei_list.length < data.total) {
          this.getData(data.next_page_url);
        }
        this.project_list = this.guonei_list;
      });
    },
    changeTab: function(el) {
      if (el) {
        this.isChina = true;
        this.project_list = this.guonei_list;
      } else {
        this.isChina = false;
        this.project_list = this.jingwai_list;
      }
    },
    showPop: function(item) {
      this.pop_data = item;
      this.isPop = true;
    },
    hidePop: function() {
      this.isPop = false;
    }
  }
};
</script>

<style lang="less" scoped>
@import "../assets/less/global.less";
.project {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
  margin-top: 100px;
  // max-height: 78%;
  // overflow: scroll;
  // overflow-x: hidden;
  // &::-webkit-scrollbar {
  //   width: 1px;
  //   background: @bordercolor;
  // }
  @media screen and (max-width: 768px) {
    margin-top: 10px;
  }
  .change_lang {
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    .title {
      h2 {
        font-size: 32px;
        font-weight: 400;
      }
      @media screen and (max-width: 768px) {
        display: none;
      }
    }
    .btn {
      background: #000000;
     height: max-content;
      border-radius: 35px;
      span {
        display: inline-block;
        font-size: 14px;
        padding: 14px 25px;
        color: #ffffff;
        @media screen and (max-width: 768px) {
          padding: 10px 25px;
        }
      }
      .active {
        background: #63656a;
        border-radius: 35px;
      }
    }
  }
  .project_list {
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    margin-top: 35px;
    // max-height: 60%;
    // overflow: scroll;
    // overflow-x: hidden;
    // &::-webkit-scrollbar {
    //   width: 1px;
    //   background: @bordercolor;
    // }
    @media screen and (max-width: 768px) {
      margin-top: 20px;
    }
    ul {
      width: 100%;
    }
    li {
      display: inline-block;
      width: 20%;
      @media screen and (max-width: 768px) {
        width: 33.333%;
      }
      padding: 30px;
      border: 1px solid @bordercolor;
      margin: 0 0 -1px -1px;
      @media screen and (max-width: 768px) {
        padding: 20px;
      }
      .img {
        width: 84px;
        height: 84px;
        margin: 0 auto;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        @media screen and (max-width: 768px) {
          width: 64px;
          height: 64px;
        }
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>
